<template>
  <el-row>
    <el-col :span="24">
      <el-card>
        <div slot="header" class="clearfix flex justify-between">
          <span>{{$t('addRouteView.title')}}</span>
        </div>
        <el-form 
          :model="addRouteViewInfo" 
          :rules="rules" 
          ref="addRouteForm"
          label-width="120px"
        >
          <el-form-item :label="$t('addRouteView.orderType')" prop="orderTypeCd">
            <el-select
              v-model="addRouteViewInfo.orderTypeCd"
              :placeholder="$t('addRouteView.orderTypePlaceholder')"
              style="width:100%"
            >
              <el-option 
                value="Q" 
                :label="$t('addRouteView.query')"
              ></el-option>
              <el-option 
                value="D" 
                :label="$t('addRouteView.businessAccept')"
              ></el-option>
            </el-select>
          </el-form-item>

          <el-form-item :label="$t('addRouteView.invokeLimitTimes')" prop="invokeLimitTimes">
            <el-input
              v-model.number="addRouteViewInfo.invokeLimitTimes"
              :placeholder="$t('addRouteView.invokeLimitTimesPlaceholder')"
            ></el-input>
          </el-form-item>

          <el-form-item :label="$t('addRouteView.invokeModel')" prop="invokeModel">
            <el-select
              v-model="addRouteViewInfo.invokeModel"
              :placeholder="$t('addRouteView.invokeModelPlaceholder')"
              style="width:100%"
            >
              <el-option 
                value="S" 
                :label="$t('addRouteView.syncMode')"
              ></el-option>
              <el-option 
                value="A" 
                :label="$t('addRouteView.asyncMode')"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </el-card>
    </el-col>
  </el-row>
</template>

<script>
export default {
  name: 'AddRouteView',
  props: {
    callBackListener: String,
    callBackFunction: String
  },
  data() {
    return {
      addRouteViewInfo: {
        flowComponent: 'addRouteView',
        orderTypeCd: '',
        invokeLimitTimes: 1000,
        invokeModel: 'S'
      },
      rules: {
        orderTypeCd: [
          { required: true, message: this.$t('addRouteView.orderTypeRequired'), trigger: 'change' },
          { min: 1, max: 4, message: this.$t('addRouteView.orderTypeLength'), trigger: 'blur' }
        ],
        invokeLimitTimes: [
          { required: true, message: this.$t('addRouteView.invokeLimitTimesRequired'), trigger: 'blur' },
          { type: 'number', message: this.$t('addRouteView.invokeLimitTimesNumber'), trigger: 'blur' }
        ],
        invokeModel: [
          { required: true, message: this.$t('addRouteView.invokeModelRequired'), trigger: 'change' },
          { max: 50, message: this.$t('addRouteView.invokeModelLength'), trigger: 'blur' }
        ]
      }
    }
  },
  watch: {
    addRouteViewInfo: {
      deep: true,
      handler(newVal) {
        console.log(newVal)
        this.saveAddRouteInfo()
      }
    }
  },
  methods: {
    saveAddRouteInfo() {
      this.$refs.addRouteForm.validate((valid) => {
        if (valid) {
          this.$emit(this.callBackListener, this.callBackFunction, this.addRouteViewInfo)
        }
      })
    },
    onIndex(index) {
      console.log(index);
      this.addRouteViewInfo.index = index
    }
  }
}
</script>

<style scoped>
.el-form-item {
  margin-bottom: 22px;
}
</style>